module.exports = __webpack_public_path__ + "stats.5e867685.webm";